<template>
    <span class='menu-item'
          :class='{english: (language === "en")}'>

        <router-link v-if='language === "nl"'
                     :to="{name: 'programma', params: {language: 'nl', slug: ''}}">Programma</router-link>
        <router-link v-if='language === "en"'
                     :to="{name: 'programma', params: {language: 'en', slug: ''}}">Programme</router-link>

        <router-link v-if='language === "nl"'
                     :to="{name: 'overons', params: {language: 'nl', slug: ''}}">Over ons</router-link>
        <router-link v-if='language === "en"'
                     :to="{name: 'overons', params: {language: 'en', slug: ''}}">About</router-link>
    </span>
</template>

<script>
export default {
  name: 'dsMenu',
  props: ['language']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
.menu-item {
  height: 2 * $baseline;
  font-size: $large-text;
  white-space: nowrap;
  text-decoration: none;
  text-align: left;
  position: absolute;
  bottom: 2 * $baseline;
  @include screen-size ('x-small') {
    height: auto;
    padding-top: 3 * $baseline;
    position: static;
    a {
      display: block;
      margin-bottom: 2 * $baseline;
      margin-right: 0;
      &:first-child {
        margin-top: 2 * $baseline;
      }
    }
  }
  a {
    position: relative;
    top: 5px;
    word-spacing: -0.1em;
    letter-spacing: -0.5px;
    margin-right: 20px;
    border-bottom: none;
    &:last-child {
      margin-right: 0;
    }
  }
  &.english {
    a {
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.menu-title {
  position: absolute;
  bottom: 1.5 * $baseline;
}
.router-link-active {
  color: $high-light;
}
</style>



// WEBPACK FOOTER //
// dsMenu.vue?0b574170